import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { useReportSingle } from "./Hooks";
import Loading from "../../../Common/Components/Loading";

function Index() {
  const location = useLocation();
  const { getData, data, loading } = useReportSingle();
  useEffect(() => {
    getData({
      bug_id: location.state && location.state.id,
    });
  }, []);
  return (
    <div className="card">
      <div className="card-body">
        {loading ? (
          <Loading count={1} col={12} height={300} />
        ) : (
          <div>
            <div className="d-flex flex-column justify-content-between">
              <h4>عنوان</h4>
              <p>{data.title}</p>
            </div>
            <div className="d-flex flex-column justify-content-between">
              <h4>پیام</h4>
              <p>{data.message}</p>
            </div>
            <div className="d-flex flex-column justify-content-between">
              <h4>فایل ها</h4>
              <img
                src={data.documents}
                width={"200px"}
                height={"200px"}
                alt=""
              />
              {/* <h6>{data.documents}</h6> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Index;
